// extracted by mini-css-extract-plugin
export default {"tablehead":"RawMaterialDataTable_tablehead__O3wMK","custom-striped-table":"RawMaterialDataTable_custom-striped-table__V3+lT"};